import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {Subscription} from 'rxjs';

// These are used for the transition

/**
 * This is meant to provide a generic notification for all our filters. It includes the following:
 *
 * @Input panelFiltered: when true, this notification shows up. This defaults to true to allow the mere use of *ngIf.
 * @Output filter: this fires when the filter text is clicked.
 * 		NOTE: it is intended to make the filter show up. I didn't implement it here because you have to supply a template.
 * @Output clearFilter: this fires when the clear filter text is clicked.
 * 		NOTE: this is intended to clear out the filter AND reset the cancel state. Again, it's component specific.
 */
@Component({
	selector: 'filter-notification',
	templateUrl: './filter-notification.component.html',
	styleUrls: ['./filter-notification.component.css'],
	animations: [
		trigger('hovered', [
			state('no-hover', style({
				backgroundColor: 'transparent'
			})),
			state('hover', style({
				backgroundColor: '#C5CAE9'
			})),
			transition('no-hover <=> hover', [
				animate('.2s cubic-bezier(.35,0,.25,1)')
			])
		])
	]
})
export class FilterNotificationComponent implements OnInit, OnDestroy {

	// Properties
	@Input() filtered = true;
	@Output() filter = new EventEmitter<any>();
	@Output() clearFilter = new EventEmitter<any>();
	clearHover = false;
	filterHover = false;
	clearSubscription: Subscription;
	filterSubscription: Subscription;

	// Class Functions
	constructor() { }

	// Event Functions
	ngOnInit() {
		this.clearSubscription = this.clearFilter.subscribe(() => {
			this.clearHover = false;
		});
		this.filterSubscription = this.filter.subscribe(() => {
			this.filterHover = false;
		});
	}

	ngOnDestroy() {

	}

	// Methods

}
